import { useEffect, useState, useContext, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import moment from 'moment'

import useStore from '../../store/useStore'
import { DatePicker, Modal, Tooltip, Button, Input, Drawer } from 'antd'
import Preview from '../../components/memos/markDownPreview';

import type { DatePickerProps } from 'antd';
import { SettingOutlined, DashOutlined, ColumnHeightOutlined, ColumnWidthOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import { Table, Empty, Select } from 'antd'
import type { ColumnsType } from 'antd/es/table';
import { sortArr } from '../../util'
import LableDrawer from '../../components/memos/drawer'
import OfficePop from '../../components/memos/onlyoffice';

import {
    week,
    calcWeekDate,
    getNaturalMonthData,
    getMonthData,
    btnStyle,
    nowYear,
    nowMonth,
    Iprops,
    DateRet,
} from './util';
import { StorageModule } from '../../modules/storage'

import * as apis from '../../api/networkDisk'
import SelectedExecutor from '../../components/executorList/selectedExecutor'

import { getImgUrlById } from '../../util'
import user_default from '../../static/image/user_default.png'
const { TextArea } = Input;
interface DataType {
    key: React.Key;
    name: string;
}

interface Props {
    location: any,
    match: any,
    history: any
}
interface State {
    userInfo: any

}


const Schedule = (props: Props) => {
    const [state, setState] = useState<State>({
        userInfo: {}

    });
    // const [store.showDrawLabel, setVisibleMsg] = useState<boolean>(false);

    const [date, setDate] = useState<any>();
    const [year, setYear] = useState<any>();
    const [month, setMonth] = useState<any>();
    //horizontal/vertical
    const [isHorizontal, setIsHorizontal] = useState<any>(true);

    const location = useLocation()
    const [strList, setStrList] = useState<any>([]);
    const [tableDiv, setTableDiv] = useState<any>([]);

    const [list, setList] = useState<any>([]);

    const [dataType, setDataType] = useState<any>();
    //跳转过来的年月日
    const [currentDate, setCurrentDate] = useState<any>('');

    //列表开始时间
    const [startDate, setStartDate] = useState<any>([]);
    //左侧弹出标签详情
    const [labelData, setLabelData] = useState<any>([]);
    // const [store.memoInfo, setItemInfo] = useState<any>({});
    const [memoModal, setMemoModal] = useState<boolean>(false);
    //记录点击的任务索引
    const [clickIndexId, setClickIndexId] = useState<any>(null);


    // const startDate = useRef<any>(calcWeekDate(props.match.params.data));

    const weekCH: string[] = ['日', '一', '二', '三', '四', '五', '六'];


    // let columns: any = []
    const [columns, setColumns] = useState<any>([]);
    const metaList = [
        { name: '任务计划', value: 'calendar-lable calendar-lable-item1' },
        { name: '开始执行', value: 'calendar-lable calendar-lable-item2' },
        { name: '任务完成', value: 'calendar-lable calendar-lable-item3' },
        { name: '版本计划', value: 'calendar-lable calendar-lable-item4' }
    ]
    const columnsWeek: any = []
    const { store, dispatch } = useStore();

    const columnsMonth: any = []
    const columnsDay: any = []
    const columnsSeason: any = []
    const [selectList, setSelectList] = useState<any>([]);
    const [selectVal, setSelectVal] = useState<any>();
    const inputRef = useRef<any>()
    const [txt, setTxt] = useState<any>('');
    const [previewVisible, setPreviewVisible] = useState<boolean>(false);
    const [officePopVisible, setOfficePopVisible] = useState<boolean>(false);

    const [markDown, setMarkDown] = useState<any>('');

    //当前季度
    const quarters = [
        [1, 2, 3],
        [4, 5, 6],
        [7, 8, 9],
        [10, 11, 12]
    ].findIndex(v => v.some(va => va == month)) + 1;
    useEffect(() => {
        //便签注释自动聚焦
        if (memoModal) {
            setTimeout(() => {
                inputRef.current.focus({
                    cursor: 'end',
                });
            }, 500);
        }
    }, [inputRef])
    useEffect(() => {
        if (dataType) {
            props.history.push({
                pathname: `/schedule/${dataType}/${moment(store.calendarCurTime).format('YYYY-MM-DD')}`,
                query: {
                    'dataType': dataType,
                }
            })
        }
    }, [store.calendarCurTime])
    useEffect(() => {

    }, [props.match])

    useEffect(() => {
        //修改标签
        if (JSON.stringify(store.calendarLable) != '{}') {
            console.log('修改标签', store.calendarLable)
            setLabelData([{ ...store.calendarLable }])
            memoTask(props.match.params.dataType)
        }
    }, [store.calendarLable,])
    useEffect(() => {
        if (JSON.stringify(store.memoInfo) != '{}') {
            console.log('151store.memoInfo', store.memoInfo)
            memoTask(props.match.params.dataType)
        }
    }, [store.memoInfo])


    useEffect(() => {
        let params: any = props.match.params
        let data: any = params.data.split('-')
        // let type: any = window.location.hash.slice(2)
        // if (type.indexOf('/') >= 0) {
        //     type = type.slice(0, type.indexOf('/'))
        // }
        // if (type === 'schedule') {
        //     dispatch({
        //         type: 'SET_CALENDARCURTIMETYPE',
        //         data: params.dataType
        //     });
        // }

        data[0] && setYear(data[0])
        data[1] && setMonth(data[1])
        data[2] && setDate(data[2])
        let _year = data[0]
        let _month = data[1]
        let _date = data[2]
        let _currentDate = moment(`${_year}-${_month}-${_date}`).format('YYYY-MM-DD')
        setStartDate([]);
        setDataType(params.dataType)
        setCurrentDate(_currentDate)
        console.log('dataType', dataType, props.match.params.dataType)
        let nums: any = 0
        let str: any = ""
        let _dataType = props.match.params.dataType
        if (_dataType !== 'day') {
            setIsHorizontal(false)
        } else {
            setIsHorizontal(isHorizontal)
        }
        let _startDate: any = []
        if (_dataType == 'week') {
            //取当周的起始时间
            setStartDate(calcWeekDate(props.match.params.data));
            _startDate = calcWeekDate(props.match.params.data)
            setColumns(columnsWeek)
            nums = 52
            str = '周'
            setSelectVal((_month == 1 && _date == 1) ? 1 : moment(props.match.params.data).week())
        } else if (_dataType == 'month') {
            //取当前月份
            setStartDate(getNaturalMonthData(_year, _month, 1));
            _startDate = getNaturalMonthData(_year, _month, 1)
            setColumns(columnsMonth)
            nums = 12
            str = '月'
            setSelectVal(parseInt(_month))

        } else if (_dataType == 'day') {
            //取当前日期
            setStartDate([_currentDate]);
            _startDate = [_currentDate]
            setColumns(columnsDay)
        } else if (_dataType == 'season') {
            console.log('columnsWeek', columnsWeek)
            //算季度起始时间
            let start: any = moment(moment(`${_year}-${_month}-${_date}`).format('YYYY-MM-DD')).startOf('quarters').format('YYYY-MM-DD');
            let end: any = moment(moment(`${_year}-${_month}-${_date}`).format('YYYY-MM-DD')).endOf('quarters').format('YYYY-MM-DD')
            setStartDate([start, end]);
            _startDate = [start, end]
            setColumns(columnsSeason)
            nums = 4
            str = '季度'
            setSelectVal(quarters)
        }
        let arr: any = []
        for (let i = 1; i < nums + 1; i++) {
            arr.push({ value: i, label: `${i}${str}` })
        }
        setSelectList(arr)
        dealColumns(data[0], data[1], _startDate)
    }, [window.location.hash, props.match, isHorizontal])
    useEffect(() => {

        let type: any = window.location.hash.slice(2)
        if (type.indexOf('/') >= 0) {
            type = type.split('/')[1]
        }
        console.log('props.match.params.dataType', props.match.params.dataType, type, store.calendarCurTimeType, StorageModule.get('calendarType'))
        if (props.match.params.dataType == type) {
            if (startDate && startDate.length > 0) {
                console.log('各种状态', startDate)
                setList([])
                setStrList([])
                setTimeout(() => {
                    memoTask(props.match.params.dataType)
                }, 500);

            }
        } else {
            //    if(props.match.params.dataType == StorageModule.get('calendarType')){
            //       if (startDate && startDate.length > 0) {
            //         console.log('各种状态1', startDate)
            //         memoTask(props.match.params.dataType)
            //     }
            //    }
        }
    }, [startDate.length, currentDate, store.calendarExecutorRowKeys, store.calendarCurTimeType, store.subjectCurType, store.calendarExecutor?.id])

    // useEffect(() => {
    //     if (!store.showDrawLabel) {
    //         setClickIndexId(null)
    //     }
    // }, [store.showDrawLabel])
    const dealPreviewData = (data: any) => {
        console.log(data, data.ownerId)
        let _params: any = {}
        _params.content = data.content
        _params.tagMetas = data.tagMetas
        _params.id = data.id
        _params.$operate$ = "save"
        _params.topicIds = data.topicIds
        _params.topicNames = data.topicNames
        _params.ownerId = data.ownerId
        _params.mimeType = data.mimeType
        if (data.mimeType) {
            let _tagMetaOrg: any = {}
            _tagMetaOrg = store.tagMeta.find((i: any) => i.mimeType == data.mimeType)
            if (data.mimeType == 'text/markdown') {
                _params.tagMetas.unshift({
                    ..._tagMetaOrg,
                    content: data.content
                })
            } else if ((data.mimeType == 'image/*')) {
                _params.tagMetas.unshift({
                    instance: {
                        imagePath: data.imagePath,
                    },
                    ..._tagMetaOrg,
                    content: data.content
                })
            } else if ((data.mimeType == 'image/m2ni-img-notas')) {


                data.annotation.map((i: any) => {
                    i.isCompile = false
                    i.subject = i.description
                    i.description = i.description
                    i.isSelect = false
                    i.isCheck = false
                    i.ownerId = data.ownerId

                })
                _params.tagMetas.unshift({
                    instance: {
                        imagePath: data.imagePath,
                        annotation: data.annotation
                    },
                    ..._tagMetaOrg,
                    content: data.content
                })
            }


        }
        return _params
    }
    const formatPreview = (data: any) => {
        setClickIndexId(data.id)
        console.log(data, store.memoInfo)
        if (data.mimeType?.indexOf('image') > -1) {
            dispatch({
                type: 'SET_IMGPREVIEW',
                data: true
            });
        } else if (data.mimeType == 'application/msword' || data.mimeType == 'application/vnd.ms-excel' || data.mimeType == 'application/vnd.ms-powerpoint') {
            setOfficePopVisible(true)
        } else {
            setMarkDown(data.content)
            setPreviewVisible(true)
        }
        let _params: any = dealPreviewData(data)
        dispatch({
            type: 'SET_MEMOINFO',
            data: { content: data.content, data: { ..._params } }
        });
    }
    const getConvertHtml = (data: any) => {
        let _params: any = dealPreviewData(data)
        dispatch({
            type: 'SET_CNODE',
            data: data
        });
        dispatch({
            type: 'SET_MYEDITMEMO',
            data: { content: data.content, data: { ..._params } }
        });
        dispatch({
            type: 'SET_LABELPOP',
            data: true
        });
        // setMarkDown(data)
        // setPreviewVisible(true)
    }

    const memoTask = async (type: any, executorIds?: any) => {
        try {
            let params: any = {}
            console.log('startDate', startDate)
            if (startDate[0] == 'Invalid date') {
                return
            }
            state.userInfo = StorageModule.getUser().user
            // if (type === 'week') {

            // } else if (type === 'month') {
            // }
            params.startDate = moment(startDate[0]).format('YYYY-MM-DDTHH:mm:[00]')
            params.endDate = moment(startDate[startDate.length - 1]).format('YYYY-MM-DDT[23]:[59]:[59]')
            // params.executorIds = [state.userInfo.id]
            // if (executorIds) {
            //     params.executorIds = executorIds
            // } else {
            //     params.executorIds = (store.calendarExecutorRowKeys.length > 0) ? store.calendarExecutorRowKeys : [state.userInfo.id]
            // }
            // 默认：executorIds = [当前登陆用户id]
            // 当前主题的任务：topicIds = [当前主题id]
            // 全部：只有查询开始和结束时间，没有其他的请求参数。
            if (store.subjectCurType === 'default') {
                params.executorIds = [state.userInfo.id]
            }
            if (store.subjectCurType === 'current') {
                params.topicIds = [store.subjectInfo?.subjectId]
            }
            if (store.subjectCurType === 'all') {
                delete params['executorIds']
            }
            if (store.calendarExecutorRowKeys.length > 0) {
                params.executorIds = store.calendarExecutorRowKeys
            }
            if (store.calendarExecutor?.id) {
                params.executorIds = store.calendarExecutor?.id
            }
            let res: any = await apis.memoLask(params)
            if (res.ok) {
                // if (dataType === 'day') {
                //     dealDayDate(res.data)
                // } else {
                //     dealDate(res.data)
                //     setList(res.data)
                // }
                // dispatch({
                //     type: 'SET_MEMOINFO',
                //     data: res.data.filter((i: any) => i.id === store.memoInfo.data.id)[0] || store.memoInfo.data.id
                // });

                dealDayDate(res.data)

            }
        } catch (e) {
            console.log(e)
        }
    }
    const setItemInfo = (item: any) => {
        dispatch({
            type: 'SET_MEMOINFO',
            data: { ...store.memoInfo, data: item }
        });
    }
    const dealColumns = (_year: any, _month: any, _startDate: any) => {
        console.log('dealColumns', _year, _month, _startDate)
        for (let i = 0; i < new Date(_year, _month, 0).getDate(); i++) {
            columnsMonth.push(<div className={`${styles.title} title`} style={{ width: `${100 / new Date(_year, _month, 0).getDate()}%` }} ><div >
                <div >{i + 1}</div>
                <div className='f12' style={{ color: '#B1B1B1' }}>{weekCH[moment(`${_year}-${_month}-${i + 1}`).day()]}</div>

            </div></div>)
        }
        for (let i = 0; i < 24; i++) {
            columnsDay.push(<div className={`${styles.title} title`} style={{ width: `${!isHorizontal ? (100 / 24) + '%' : '50px'}`, height: `${isHorizontal ? '70px' : '50px'}` }} ><div >
                <div >{i}</div>
                <div className='f12' style={{ color: '#B1B1B1' }}>时</div>
            </div></div>)
        }
        week.map((it, index) => {
            columnsWeek.push(<div className={`${styles.title} title`} style={{ width: `${100 / week.length}%` }} ><div >
                <div >周{it}</div>
                <div className='f12' style={{ color: '#B1B1B1' }}>{moment(_startDate[index]).format('MM-DD')}</div>
            </div></div>)
        })
        //算选中季度有几周
        let col: any = moment(_startDate[1], 'YYYY-MM-DD HH:mm:ss').diff(moment(_startDate[0], 'YYYY-MM-DD HH:mm:ss'), 'days') + 1
        // let weekNums:any=(quarters==1)?
        for (let i = 0; i < Math.ceil(col / 7); i++) {
            columnsSeason.push(<div className={`${styles.title} title`} style={{ width: `${100 / 12}%` }} ><div >
                {/* 排除1.1号 */}
                {/* moment().startOf('isoWeek');//当前周开始时间 */}
                {/* moment().endOf('isoWeek');//当前周结束时间 */}
                <div >{(moment(_startDate[0]).month() == 0 && (moment(_startDate[0]).format('DD') == '01') || moment(_startDate[0]).format('DD') == '1') ? 1 + i : moment(_startDate[0]).week() + i}</div>
                <div className='f12' style={{ color: '#B1B1B1' }}>周</div>
            </div></div>)
        }
    }
    let arr: any = []
    let colspan: any = 0
    let sIndex: any = 0
    //处理天列表
    const dealDayDate = (data: any) => {
        setList([])
        let Y: any = []
        data.map((item: any, index: any) => {
            let _tagMetas: any = []
            item.tagMetas.map((i: any) => {
                _tagMetas.push({ ...i, ...i.instance })
            })
            // console.log(_tagMetas)
            Y.push({ ...item.tagMetas[item.tagMetas.length - 1].instance, ...item, tagMetas: _tagMetas })
        })
        let executorArr: any = []
        executorArr = sortArr(Y, 'executorId', 'manHour')
        let newList: any = []
        executorArr.map((item: any) => {
            // dealDate(item)
            newList = newList.concat(item)
        })
        setList(newList)
    }
    //控制点击同一弹框，收起
    // let clickIndexId: any = null
    //处理表格跨行数据
    const dealDate = (info: any, index?: any, dataList?: any) => {
        let data = dataList
        //是否倒序
        let invertedOrder: any = false
        //每个执行人工作总和
        let total: any = 0
        // data.map((it: any, index: any) => {
        let str: any = []
        let item: any = info
        //合并版本计划
        if (dataType === 'day') {
            if ((moment(currentDate).weekday() === 5 || moment(currentDate).weekday() === 6) && !item.overtime) {
                return;
            }
        }
        if (item.releaseTag) {
            item.tagMetas.unshift({ ...item.releaseTag, name: '版本计划', manHour: item.releaseTag.release })
        }
        //最新任务时间
        let newTaskItem: any = item.tagMetas[item.tagMetas.length - 1]
        // console.log('newTaskItem',newTaskItem)
        let bgColorClass: any = 'item0'
        bgColorClass = (newTaskItem.name == '任务完成') ? 'item3' : (newTaskItem.name == '开始执行') ? 'item2' : 'item1'
        let start: any, end: any, startTime: any, finishTime: any, nums: any, _manHour: any
        nums = columns.length
        if (dataType === 'day') {
            start = moment(startDate[0], 'YYYY-MM-DD HH:mm:ss').diff(item.startTime, 'days');
            end = moment(startDate[startDate.length - 1], 'YYYY-MM-DD HH:mm:ss').diff(item.finishTime, 'days');
            startTime = moment(moment(item.startTime).format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
            finishTime = moment(moment(item.finishTime).format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
            _manHour = Number(item.manHour)
            colspan = _manHour
            if (_manHour > 8) {
                //_manHour大于8 说明跨天 ，直接满行显示
                colspan = 10
                sIndex = 9
            } else {
                //_manHour小于8，说明是正常显示
                if (index == 0) {
                    //设置第一天数据索引位置
                    sIndex = 9
                } else {
                    //索引等于起始位置加自己的任务小时
                    sIndex = sIndex + Number(data[index - 1].manHour)
                    //如果该执行人的上几条数据的累积sIndex大约18代表越界或者当条数据计算出的索引值大于18  则倒序表示 
                    if (sIndex >= 18 || (sIndex + _manHour) > 18) {
                        sIndex = 18 - Number(data[index].manHour) + 1
                    }

                }
            }
            total += total + colspan
        } else {
            //start > 0 任务开始时间越界 end<0 任务结束时间越界 start=0 || end==0 end因为23:59:59所以差一天 
            start = moment(startDate[0], 'YYYY-MM-DD HH:mm:ss').diff(newTaskItem.startTime, 'days');
            end = moment(startDate[startDate.length - 1], 'YYYY-MM-DD HH:mm:ss').diff(newTaskItem.finishTime, 'days');
            //startTime 任务实际开始时间finishTime任务实际结束时间 
            startTime = moment(moment(newTaskItem.startTime).format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
            finishTime = moment(moment(newTaskItem.finishTime).format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
            //colspan跨行数 sIndex起始位置
            if (dataType === 'season') {
                //当前所开始时间超出本季度开始时间，则sIndex=0
                let tran: any = startTime.diff(startDate[0], 'days');
                // console.log('tran', tran, startTime.format('YYYY-MM-DD'), startDate[0])
                if (tran <= 0) {
                    sIndex = 0
                } else {
                    sIndex = Math.ceil(tran / 7) - 1
                }
                colspan = Math.ceil((finishTime.diff(startTime, 'days') + 1) / 7);
            } else {
                sIndex = (start > 0) ? 0 : startDate.findIndex((i: any) => i === moment(newTaskItem.startTime).format('YYYY-MM-DD'))
                colspan = finishTime.diff(startTime, 'days') + 1;
            }
            //处理实际开始任务日期越界
            if (start > 0) {
                colspan = colspan - start
            }
            //处理实际结束任务日期越界
            if (end < 0) {
                colspan = colspan + end
            }
        }
        console.log(item.tagMetas)
        // console.log(`,startDate:${startDate[0]},newTaskItem.startTime:${newTaskItem.startTime},start: ${start}，end: ${end}，colspan: ${colspan}，sIndex: ${sIndex},manHour:${_manHour}`)
        //循环表头列数
        let _executorUser: any = (item.executorUser) ? item.executorUser : newTaskItem.executorUser
        let horizontalHour = 0
        for (let i = 0; i < nums; i++) {
            let _width: any = 100 / columns.length * ((i == sIndex) ? colspan : 1)
            let hour = item.tagMetas[item.tagMetas.length - 1]?.manHour || 0
            horizontalHour = horizontalHour + hour
            // console.log('horizontalHour', horizontalHour)
            if (isHorizontal && index != 0 && hour <= 8) {
                console.log('isHorizontal', arr)
                // str[str.length - 1] = "<div>11</div>"
                // str.push(<div>11</div>)
            } else {
                str.push(<div className={`td ${(i == sIndex) ? 'colspan' : ''} `} style={{ flex: `${isHorizontal ? "auto" : `0 0 ${_width}%`}`, width: `${isHorizontal ? `100%` : _width + '%'}`, height: `${isHorizontal ? `${(i == sIndex) ? `${colspan * 70}px` : '70px'}` : '50px'}` }} >
                    <div className={`colspan-box ${(clickIndexId == item.id) ? " colspan-active" : ''} ${bgColorClass} ${styles.colspanBoxItem}`} onDoubleClick={() => {
                        getConvertHtml(item)
                    }}>
                        {(i == sIndex) ? <div style={{ width: `calc(100% - 40px)` }} onClick={() => { setItemInfo(item); getDownUp(item, 'onlyCheck') }} data-flex='main:justify cross:top'>
                            <div data-flex='main:left cross:top' style={{ overflow: 'hidden', flex: '0 0 26px' }}>
                                <Tooltip title={_executorUser?.username}>
                                    <img className="item-image" style={{ flexShrink: '0', borderRadius: '100%', width: '24px', height: '24px', verticalAlign: 'middle', backgroundSize: "100%", marginRight: '10px' }} alt="" src={(_executorUser?.avatar) ? getImgUrlById(_executorUser?.avatar) : user_default}
                                    />
                                    {/* width: (store.showDrawLabel) ? `calc(${_width} - 350px)` : _width  */}
                                </Tooltip>

                            </div>
                            {!isHorizontal && <div className={`${isHorizontal ? '' : styles.clamp}`} style={{ width: '100%' }}>{item.content}</div>
                            }
                            <div data-flex='main:justify cross:center'>{item.tagMetas.map((j: any) => (<div className={`${metaList.filter((x: any) => (x.name === j.name))[0]?.value}`}>{j.manHour}</div>))}</div>

                        </div> : ''}
                        {(isHorizontal && i == sIndex) && <div className={`${isHorizontal ? '' : styles.clamp}`} style={{ width: '100px', 'wordBreak': 'break-all' }}>{item.content}</div>}

                        {(i == sIndex) ? <><DashOutlined className='mr-10 setting setting_dash' onClick={() => {
                            // node.size(220, 220);
                            // node.setData({ ...node.data, isMore: true })
                            formatPreview(item)
                        }} /><SettingOutlined className='setting' onClick={() => { setItemInfo(item); getDownUp(item) }} /></> : ''}

                    </div>
                </div>)
            }
            //处理前后越界任务数据 合并单元格后，如果i等于合并单元格内的值 后续单元格不必渲染，结束本次循环
            if (i === (nums - colspan)) {
                break
            }
            //处理没越界任务数据，跳过跨行数，不去渲染跨行内后续的单元格，以完成合并单元格效果
            if ((i - sIndex < sIndex && i - sIndex > 0)) {
                continue
            }
        }
        arr.push(str)
        // })
        return str
    }
    const onChange: DatePickerProps['onChange'] = (date, dateString) => {
        dispatch({
            type: 'SET_CALENDARCURTIME',
            data: `${moment(date).format('YYYY-MM-DD')}`
        });
        props.history.push({
            pathname: `/schedule/${dataType}/${moment(date).format('YYYY-MM-DD')}`,
            query: {
                'dataType': dataType,
            }
        })

    };
    const saveNode = async () => {
        //不可新建空白注释
        console.log(store.memoInfo)
        let res: any = await apis.putMemo(store.memoInfo.data.id, { content: txt })
        if (res.ok) {
            setMemoModal(false)
            memoTask(dataType)
            setItemInfo({ ...store.memoInfo, content: txt })
        }
    }
    const getDownUp = (item: any, type?: any) => {
        console.log(clickIndexId, item.id)
        if (type == 'onlyCheck') {
            setClickIndexId(item.id)
            return
        }
        if (clickIndexId === item.id && store.showDrawLabel) {
            // setVisibleMsg(false)
            dispatch({
                type: 'SET_SHOWDRAWLABEL',
                data: false
            });
            setClickIndexId(null)
            // clickIndexId = null
        } else {
            // setVisibleMsg(true)
            dispatch({
                type: 'SET_SHOWDRAWLABEL',
                data: true
            });
            setClickIndexId(item.id)
            // clickIndexId = index
            setLabelData(item.tagMetas)
            setItemInfo(item)
        }
    }
    return (
        <div data-flex={`main:${store.showDrawLabel ? 'justify' : 'center'} cross:top`} >
            <div className={styles.box} data-flex='dir:top main:left cross:center' style={{ padding: '0 30px', width: (store.showDrawLabel) ? 'calc(100% - 360px)' : '100%' }}>
                <div className={styles.header} data-flex='main:justify cross:center' >
                    <div>
                        {dataType === 'day' ? <>{`${moment(currentDate).format('YYYY年MM月DD日')}`}
                            <DatePicker className='ml-10' allowClear={false} value={moment(currentDate)} onChange={onChange} />
                        </> : <>
                            {/* 处理1.1日为52周的情况 */}
                            {dataType === 'week' && `${year}年第${(month == 1 && date == 1) ? 1 : moment(currentDate).week()}周`}
                            {dataType === 'month' && `${year}年${month}月`}
                            {dataType === 'season' && `${year}年${quarters}季度`}
                            <DatePicker className='ml-10' allowClear={false} value={moment(currentDate)} onChange={onChange} picker={(dataType === 'season') ? 'quarter' : dataType} />
                        </>}
                        {dataType == 'day' && <>{isHorizontal ? <ColumnWidthOutlined className='ml-10' onClick={() => { setIsHorizontal(false) }} />
                            : <ColumnHeightOutlined className='ml-10' onClick={() => { setIsHorizontal(true) }} />}</>}
                    </div>
                    <div data-flex='main:right cross:center'>
                        <SelectedExecutor onClick={(e) => {
                        }} />
                    </div>
                </div>
                {/* <>{tableDiv}</> */}
                {!isHorizontal && <div className={`${styles.table} ${!isHorizontal ? 'vertical' : 'horizontal'}`} style={{ width: '100%' }}>
                    <div data-flex='main:center cross:center'>
                        {columns}
                    </div>
                    <div style={{ maxHeight: '65vh', overflow: 'overlay' }}>
                        {list.length > 0 ? <>{list.map((i: any, index: any) => {
                            return <div data-flex='main:center cross:center' className='tr' >{dealDate(i, index, list)}</div>
                        })}</> : <Empty style={{ background: '#fff', margin: '0', padding: "70px 0" }} image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                    </div>
                    {/* <div style={{ maxHeight: '65vh', overflow: 'overlay' }}>
                        {strList.length > 0 ? <>{strList.map((i: any, index: any) => (
                            <div data-flex='main:center cross:center' className='tr' >
                                {i}</div>
                        ))}</> : <Empty style={{ background: '#fff', margin: '0', padding: "70px 0" }} image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                    </div> */}
                    <div data-flex='main:center cross:center'>
                        {columns}
                    </div>

                </div>
                }
                {(dataType == 'day' && isHorizontal) && <div className={`${styles.horizontal}`}><div data-flex='main:justify cross:center' className={`${styles.table}`} style={{ width: '100%' }}>
                    <div data-flex='dir:top main:justify cross:center'>
                        {columns}
                    </div>
                    <div style={{ width: '100%', overflow: 'auto' }} >
                        <div data-flex={`${list.length > 0 ? 'main:left cross:center' : 'main:center cross:center'}`}>
                            {list.length > 0 ? <>{list.map((i: any, index: any) => {
                                return dealDate(i, index, list) != '' && <div data-flex="dir:top main:left cross:center" style={{ flex: '1' }} className='tr' >{dealDate(i, index, list)}</div>
                            })}</> : <Empty style={{ background: '#fff', margin: '0', padding: "70px 0" }} image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                        </div></div>
                    <div data-flex='dir:top main:left cross:center'>
                        {columns}
                    </div>
                </div>
                </div>
                }
            </div>
            <LableDrawer startDate={startDate} title={'任务内容'} visible={store.showDrawLabel} onClose={() => {
                dispatch({
                    type: 'SET_SHOWDRAWLABEL',
                    data: false
                });
            }} />
            <Modal
                centered
                onCancel={() => {
                    setMemoModal(false)
                }}
                footer={[
                    <Button className='btn ' key='btn1' type="primary" onClick={() => {
                        saveNode()
                    }}>保存</Button>,
                ]}
                title={`编辑`}
                width={'60%'}
                open={memoModal}>
                <TextArea rows={6} placeholder={`请输入便签内容`} ref={inputRef} value={txt} onChange={(e) => {
                    setTxt(e.target.value)
                }} onPressEnter={() => {
                }} />
            </Modal>
            <Preview visible={previewVisible} content={markDown} onClose={() => { setPreviewVisible(false); setMarkDown('') }} />
            <Modal
                centered
                onCancel={() => {
                    setOfficePopVisible(false);
                }}
                title={`编辑`}
                width={'60%'}
                open={officePopVisible}>
                <OfficePop visible={officePopVisible} isEdit={false} onClose={() => { setOfficePopVisible(false); }}></OfficePop>
            </Modal>
        </div>
    )
}

export default Schedule
